import HomeView from '@/views/HomeView.vue'
import LoginView from '@/views/LogInView.vue'
import ResetView from '@/views/ResetView.vue'
import ProfileView from '@/views/ProfileView.vue'
import BlueprintView from '@/views/BlueprintView.vue'
import BuildView from '@/views/BuildView.vue'
import UploadEstimateView from '@/views/UploadEstimateView.vue'
import OverviewView from '@/views/OverviewView.vue'
import PricingRulesView from '@/views/PricingRulesView.vue'
import AdasIqView from '@/views/AdasIqView.vue'
export default [
  {
    path: '/login',
    name: 'login',
    meta: { allowAnonymous: true },
    component: LoginView
  },
  {
    path: '/reset',
    name: 'reset',
    meta: { allowAnonymous: true },
    component: ResetView
  },
  {
    path: '/',
    name: 'home',
    meta: { layout: 'side-nav' },
    component: HomeView
  },
  {
    path: '/profile',
    name: 'profile',
    meta: { layout: 'default' },
    component: ProfileView
  },
  {
    path: '/inspections',
    name: 'inspections',
    meta: { layout: 'default' },
    component: BlueprintView
  },
  {
    // Issue 622: PDF estimate upload/review page (reached from the Upload PDF button on the grid).
    path: '/upload-estimate',
    name: 'upload-estimate',
    meta: { layout: 'default' },
    component: UploadEstimateView
  },
  {
    // #668: VIN-based ADAS Systems Overview, matching ADAS Map's /add-inspection page.
    path: '/overview',
    name: 'overview',
    meta: { layout: 'side-nav' },
    component: OverviewView
  },
  {
    // #659: Discount Rules.
    path: '/pricing-rules',
    name: 'pricing-rules',
    meta: { layout: 'side-nav' },
    component: PricingRulesView
  },
  {
    // #620: ADAS IQ as a page (the ADAS IQ service's embed). Nav entry, and the
    // guard, only for users ADAS IQ allows (stores/adasIq.js).
    path: '/adas-iq',
    name: 'adas-iq',
    meta: { layout: 'side-nav' },
    component: AdasIqView
  },
  {
    path: '/build',
    name: 'build',
    meta: { layout: 'default' },
    component: BlueprintView
  },
  {
    path: '/about',
    name: 'about',
    meta: { layout: 'default' },
    // route level code-splitting
    // this generates a separate chunk (About.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/AboutView.vue')
  }
]
